/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PostApiV1BannerMutationRequest,
  PostApiV1BannerMutationResponse,
  PostApiV1Banner400,
  PostApiV1Banner401,
  PostApiV1Banner404,
  PostApiV1Banner500,
} from "../../types/bannerRegistroController/PostApiV1Banner.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { postApiV1Banner } from "../../clients/bannerRegistroController/postApiV1Banner.ts";

export const postApiV1BannerMutationKey = () =>
  [{ url: "/api/v1/banner" }] as const;

export type PostApiV1BannerMutationKey = ReturnType<
  typeof postApiV1BannerMutationKey
>;

export function postApiV1BannerMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<PostApiV1BannerMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const mutationKey = postApiV1BannerMutationKey();
  return mutationOptions<
    PostApiV1BannerMutationResponse,
    ResponseErrorConfig<
      | PostApiV1Banner400
      | PostApiV1Banner401
      | PostApiV1Banner404
      | PostApiV1Banner500
    >,
    { data?: PostApiV1BannerMutationRequest },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return postApiV1Banner(data, config);
    },
  });
}

/**
 * @description Cria um novo banner (multipart/form-data). A imagem é enviada no campo 'image' e vai para o storage. **(Requer Authorization para autenticação)**
 * @summary Criar banner (Requer Authorization para autenticação)
 * {@link /api/v1/banner}
 */
export function usePostApiV1Banner<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiV1BannerMutationResponse,
      ResponseErrorConfig<
        | PostApiV1Banner400
        | PostApiV1Banner401
        | PostApiV1Banner404
        | PostApiV1Banner500
      >,
      { data?: PostApiV1BannerMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<PostApiV1BannerMutationRequest>> & {
      client?: Client;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? postApiV1BannerMutationKey();

  const baseOptions = postApiV1BannerMutationOptions(
    config,
  ) as UseMutationOptions<
    PostApiV1BannerMutationResponse,
    ResponseErrorConfig<
      | PostApiV1Banner400
      | PostApiV1Banner401
      | PostApiV1Banner404
      | PostApiV1Banner500
    >,
    { data?: PostApiV1BannerMutationRequest },
    TContext
  >;

  return useMutation<
    PostApiV1BannerMutationResponse,
    ResponseErrorConfig<
      | PostApiV1Banner400
      | PostApiV1Banner401
      | PostApiV1Banner404
      | PostApiV1Banner500
    >,
    { data?: PostApiV1BannerMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiV1BannerMutationResponse,
    ResponseErrorConfig<
      | PostApiV1Banner400
      | PostApiV1Banner401
      | PostApiV1Banner404
      | PostApiV1Banner500
    >,
    { data?: PostApiV1BannerMutationRequest },
    TContext
  >;
}
